import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Layout from '@/components/site/Layout';
import { LanguageProvider } from '@/i18n/LanguageContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { ExternalLinkProvider } from '@/contexts/ExternalLinkContext';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Strategy from '@/pages/Strategy';
import Ventures from '@/pages/Ventures';
import Services from '@/pages/Services';
import Security from '@/pages/Security';
import Contact from '@/pages/Contact';
import News from '@/pages/News';
import Media from '@/pages/Media';
import CaseStudies from '@/pages/CaseStudies';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import ProtectedRoute from '@/components/admin/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ExternalLinkProvider>
            <div className="App">
              <BrowserRouter>
                <Routes>
                  {/* Admin (no public layout) */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

                  {/* Public site */}
                  <Route path="/*" element={
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/strategy" element={<Strategy />} />
                        <Route path="/ventures" element={<Ventures />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/security" element={<Security />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/media" element={<Media />} />
                        <Route path="/case-studies" element={<CaseStudies />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                      </Routes>
                    </Layout>
                  } />
                </Routes>
              </BrowserRouter>
            </div>
          </ExternalLinkProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
